import React from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { twMerge } from "tailwind-merge";

import { Pill } from "src/base-components/Pill";
import { JSONSchemaViewerDisplayOptions } from "src/jsonSchema/viewer/JSONSchemaRenderer";

type PropertyBadgeProps = {
  name: string;
  icon?: IconDefinition;
  dataPath: string;
  isRequired?: boolean;
  displayOptions: JSONSchemaViewerDisplayOptions;
  size?: "sm" | "base" | "lg";
  bold?: boolean;
};

export const PropertyBadge: React.FC<PropertyBadgeProps> = ({
  name,
  icon,
  isRequired = false,
  displayOptions,
  size = "sm",
  bold = false,
}) => {
  return (
    <Pill size={size} variant="gray" maxWidth>
      {icon && (
        <>
          <Pill.Icon icon={icon} padding={false} />
          <div className="w-1" />
        </>
      )}
      <Pill.Text fontType="code-12">
        <span
          className={twMerge("text-gray-600", bold ? "font-semibold" : "", "")}
        >
          {name}
        </span>
        {displayOptions.showRequired && isRequired && (
          <span className="ml-1 text-indigo-500">*</span>
        )}
      </Pill.Text>
    </Pill>
  );
};
